module.exports = __webpack_public_path__ + "img/fishing-rod.fd5516ef.svg";